import React, { Component } from 'react';
import styled from 'styled-components/macro';
import translate from './TranslateHOC';
import Card from './Card';

class ProgrammePlayNext extends Component {
  constructor(props) {
    super(props);
    this.state = { isCancelled: false };
    this.handleCancel = this.handleCancel.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleCancel = () => {
    this.setState({ isCancelled: true });
    this.props.clearTimer();
  };
  handleClose = () => {
    this.setState({ isCancelled: true });
    this.props.clearTimer();
    this.props.close(); // this will trigger an unmount
  };

  render() {
    const { items, strings, moreItems } = this.props;

    return (
      <section
        className={
          'card-grid-container--play-next ' +
          (this.state.isCancelled ? 'card-grid-container--play-cancelled' : '')
        }
      >
        <div className="card-grid-container__inner--play-next">
          <div className="card-grid">
            {(Object.keys(items).length > 0 ||
              Object.keys(moreItems).length > 0) && (
              <CardGridInner>
                {Object.keys(items).length > 0 && (
                  <div className={'card-grid__next-up'}>
                    <Card
                      tag={strings.next}
                      index={items.id}
                      details={items}
                      playNow={true}
                      isFav={false}
                    ></Card>
                    {this.state.isCancelled === false && this.props.isAutoPlay && (
                      <div className="card__children">
                        <button
                          className="button-link"
                          onClick={this.handleCancel}
                        >
                          {strings.cancel}
                        </button>
                      </div>
                    )}
                  </div>
                )}

                {Object.keys(moreItems).length > 0 && (
                  <div>
                    <Card
                      tag={strings.recommended}
                      index={moreItems.id}
                      details={moreItems}
                      playNow={true}
                      isFav={false}
                    ></Card>
                  </div>
                )}
              </CardGridInner>
            )}
          </div>
        </div>
      </section>
    );
  }
}

const CardGridInner = styled.div`
  padding: 0 24px;
  grid-gap: 16px 20px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  @media screen and (min-width: 645px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export default translate(ProgrammePlayNext);
